/* eslint-disable no-undef */
declare const API_URL: string;
declare const STRIPE_PUBLIC_TOKEN: string | undefined;
export default {
  ApiUrl: API_URL,
  StripePublicToken: STRIPE_PUBLIC_TOKEN,
};
